import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import SnackbarProvider from "../../components/SnackBar";
import { view } from "../../utils/API";
import { ROLE_EDITOR } from "../../utils/helper";
import PopupBody from "../MobileApp/MobilePopup/PopupBody";
import getAllowedFields from "./helpers/getAllowedFields";

const CustomPopupWrapper = ({ actions, row, config, t, i18n }) => {
  const layer = row.sourceLayer ? row.sourceLayer : row.layer;
  const fields = layer.fields;
  const layerConfig = layer.layerConfig;
  const layerSettings = layerConfig.customPopupOps;

  let [attachments, setAttachments] = useState([]);
  let [activeTab, setActiveTab] = useState(0);

  const title = layer.getLayerTitle(t);
  useEffect(() => {
    if (!layer.capabilities.operations.supportsQueryAttachments) return;

    layer
      .queryAttachments({ objectIds: [row.attributes[layer.objectIdField]] })
      .then((response) => {
        setAttachments(Object.values(response).flat(1));
      })
      .catch((err) => {
        console.log(err);
      });
  }, [row, fields, layer]);

  const refreshAttachments = () => {
    layer
      .queryAttachments({ objectIds: [row.attributes[layer.objectIdField]] })
      .then((response) => {
        setAttachments(Object.values(response).flat(1));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const goToAttachmentTab = () => {
    setActiveTab(2);
  };

  const getFields = (filterFields) => {
    if (!Array.isArray(filterFields)) return null;

    return allowedFields.filter((field) => filterFields.includes(field.name));
  };

  const allowedFields = getAllowedFields(layer, row);
  const isEditable =
    config.role === ROLE_EDITOR && layer.capabilities.data.supportsAttachment;

  useEffect(() => {
    view.popup.visibleElements.closeButton = false;
  }, []);

  return (
    <SnackbarProvider>
      <PopupBody
        config={config}
        t={t}
        i18n={i18n}
        selectedFeature={row}
        expand={true}
        setFullScreenActive={() => {}}
        isPopup={true}
      />
    </SnackbarProvider>
  );
};

CustomPopupWrapper.propTypes = {
  row: PropTypes.object,
  config: PropTypes.object,
  t: PropTypes.func,
};

export default CustomPopupWrapper;
